export enum CampaignStatus {
  INACTIVE = 1,
  ACTIVE = 2,
  FINISHED = 3,
}
